import { createContext, Dispatch, SetStateAction } from 'react';
import { CustomerDto } from '../commons/dtos/customer.dto';

interface PublicFormContextType {
  customer?: CustomerDto;
  setCustomer: Dispatch<SetStateAction<CustomerDto | undefined>>;
  step: number;
  setStep: Dispatch<SetStateAction<number>>;
}

const PublicFormContext = createContext<PublicFormContextType>(null!);

export default PublicFormContext;
